import React, { Component } from 'react';
import { Map } from 'immutable';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { retrieveHighlightSet } from '../../actions/umoGallery';
import { highlightsSetSelected, retrieveSets } from '../../actions/sets';
import { validateSessionConnection } from '../../actions/session';
import HighlightSetItem from './HighlightSetItem';

const mapStateToProps = state => ({
  sets: state.sets,
  session: state.session,
  workspacePreview: state.workspacePreview,
});

const mapDispatchToProps = dispatch => ({
  validateSession: surl => dispatch(validateSessionConnection(surl)),
  onHighlightClick: (item) => {
    dispatch(highlightsSetSelected(item.i));
    dispatch(retrieveHighlightSet(item.i, item.n, item.d));
  },
  retrieveSets: () => dispatch(retrieveSets()),
});

class HighlightsView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isJGLoaded: false,
    };
  }
  componentDidMount() {
    this.props.retrieveSets();
  }

  componentDidUpdate(prevProps) {
    const thumbPreviewGallery = $('.highlight-preview-gallery');
    const thisObj = this;

    if (prevProps.sets.get('setsList') !== this.props.sets.get('setsList')) {
      // only refresh justified gallery when the umoList has changed OR
      // view type has changed from not justified to justified
      thumbPreviewGallery.css({ opacity: 0, visibility: 'hidden' });
      thumbPreviewGallery.justifiedGallery('destroy');
      thumbPreviewGallery.justifiedGallery({
        rowHeight: 280,
        maxRowHeight: 280,
        cssAnimation: true,
        margins: 20,
        lastRow: 'nojustify',
        randomize: false,
        waitThumbnailsLoad: false,
      }).on('jg.complete', () => {
        thumbPreviewGallery.addClass('highlight-preview-gallery--loaded').removeAttr('style');
        thisObj.setState({
          isJGLoaded: true,
        });
      }).on('jg.resize', () => {
        // this.fixImageRatio();
      });
    }
  }

  componentWillUnmount() {
    // need to turn off the jg.complete event handler since it has a setState inside. we don't
    // want the setState to trigger if the component is unmounted.
    // $('.highlight-preview-gallery').justifiedGallery('destroy').off('jg.complete');
  }

  render() {
    const setList = this.props.sets.get('setsList');
    const highlightItems = [];
    for (let i = 0; i < setList.size; i += 1) {
      highlightItems.push(<HighlightSetItem
        id={setList.get(i).toJS().i}
        key={setList.get(i).toJS().i}
        hsItem={setList.get(i).toJS()}
        onHighlightClick={this.props.onHighlightClick}
      />);
    }
    return (
      <div className="main__highlight-gallery">
        <div className="highlight-preview-gallery justified-gallery">
          {highlightItems}
        </div>
      </div>
    );
  }
}

HighlightsView.propTypes = {
  sets: PropTypes.instanceOf(Map),
  onHighlightClick: PropTypes.func,
  retrieveSets: PropTypes.func,
};

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(HighlightsView));



// WEBPACK FOOTER //
// ./src/js/components/HighlightsView/index.jsx